import { observer } from "mobx-react-lite"

import type { ZapStore } from "@/domains/minimal-pools-zap/zap-store"
import { Dialog, DialogContent } from "@/components/dialog"
import { ZapStateButtonsMap } from "@/domains/minimal-pools-zap/components/zap/composables/zap-buttons/zap-state-buttons-map"
import { ZapStateComponentMap } from "@/domains/minimal-pools-zap/components/zap/composables/zap-panels/zap-state-component-map"
import { ZapProgressIndicator } from "@/domains/minimal-pools-zap/components/zap/composables/zap-steps/zap-progress-indicator"

interface ZapDialogProps {
  poolName: string
  store: ZapStore
  onApprove: () => void
  onBackToIdle: () => void
  onCancel: () => void
  onClose: () => void
  onExecute: () => void
  onGetEstimate: () => void
  onReset: () => void
  onRetryApproval: () => void
  onRetryEstimate: () => void
  onRetryExecution: () => void
  onZapCompleteClose: () => void
}

export const ZapDialog = observer(
  ({
    poolName,
    store,
    onApprove,
    onBackToIdle,
    onCancel,
    onClose,
    onExecute,
    onGetEstimate,
    onReset,
    onRetryApproval,
    onRetryEstimate,
    onRetryExecution,
    onZapCompleteClose,
  }: ZapDialogProps) => {
    // Defensive programming - handle undefined store
    if (!store) {
      console.error("ZapDialog: store is undefined")
      return null
    }

    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/20">
        <Dialog
          open={true}
          onOpenChange={(value) => {
            if (!value) {
              onCancel()
              onClose()
              return
            }
          }}
        >
          <DialogContent
            className="gap-0 border border-p400-light bg-p400 pt-10 text-t100"
            title={`Zap into ${poolName}`}
          >
            <ZapProgressIndicator store={store} className="mb-8" />
            <div className="mb-8">
              <ZapStateComponentMap store={store} />
            </div>
            <ZapStateButtonsMap
              store={store}
              onApprove={onApprove}
              onBackToIdle={onBackToIdle}
              onCancel={onCancel}
              onExecute={onExecute}
              onReset={onReset}
              onGetEstimate={onGetEstimate}
              onRetryEstimate={onRetryEstimate}
              onRetryApproval={onRetryApproval}
              onRetryExecution={onRetryExecution}
              onZapCompleteClose={onZapCompleteClose}
            />
          </DialogContent>
        </Dialog>
      </div>
    )
  },
)
